import * as yup from 'yup';

export const qrTagBatchSchema = yup.object({
  // Requeridos
  qr_tags_amount: yup
    .number()
    .positive('Debe ser un número positivo')
    .integer('Debe ser un número entero')
    .min(1, 'Mínimo 1 QR')
    .max(1000, 'Máximo 1000 QRs')
    .required('Cantidad de QRs es requerida'),
  
  badge_size_id: yup
    .number()
    .positive()
    .integer()
    .required('Tamaño de badge es requerido'),
  
  // Opcionales pero con validación si se completan
  company_id: yup
    .number()
    .positive()
    .integer()
    .nullable(),
  
  company_name: yup
    .string()
    .max(255, 'Máximo 255 caracteres')
    .nullable(),
  
  owner_name: yup
    .string()
    .max(255, 'Máximo 255 caracteres')
    .nullable(),
  
  email: yup
    .string()
    .email('Email inválido')
    .max(255, 'Máximo 255 caracteres')
    .nullable(),
  
  billing_name: yup
    .string()
    .max(255, 'Máximo 255 caracteres')
    .nullable(),
  
  billing_cuit: yup
    .string()
    .max(50, 'Máximo 50 caracteres')
    .nullable(),
  
  billing_email: yup
    .string()
    .email('Email inválido')
    .max(255, 'Máximo 255 caracteres')
    .nullable(),
  
  billing_phone_country_code: yup
    .string()
    .matches(/^\+\d+$/, 'Debe comenzar con "+" seguido de números (ej: +54)')
    .max(10, 'Máximo 10 caracteres')
    .nullable(),
  
  billing_phone_area_code: yup
    .string()
    .max(10, 'Máximo 10 caracteres')
    .nullable(),
  
  billing_phone_number: yup
    .string()
    .max(20, 'Máximo 20 caracteres')
    .nullable(),
  
  company_tax_status_id: yup
    .number()
    .positive()
    .integer()
    .nullable(),

  qr_tag_batch_status_id: yup
    .number()
    .positive()
    .integer()
    .nullable(),

  contact_name: yup
    .string()
    .max(255, 'Máximo 255 caracteres')
    .nullable(),
  
  contact_email: yup
    .string()
    .email('Email inválido')
    .max(255, 'Máximo 255 caracteres')
    .nullable(),
  
  contact_phone_country_code: yup
    .string()
    .matches(/^\+\d+$/, 'Debe comenzar con "+" seguido de números (ej: +54)')
    .max(10, 'Máximo 10 caracteres')
    .nullable(),
  
  contact_phone_area_code: yup
    .string()
    .max(10, 'Máximo 10 caracteres')
    .nullable(),
  
  contact_phone_number: yup
    .string()
    .max(20, 'Máximo 20 caracteres')
    .nullable(),
  
}).required();